const form = {
  year: "Jahr",
  invoiceStatus: "Rechnungsstatus",
  firstName: "Vorname",
  lastName: "Nachname",
  email: "Email",
  phone: "Telefon",
  address: "Anschrift",
  status: "Status",
  password: "Password",
  confirmPassword: "Confirm Password",
  dateOfEntry: "Datum Eintritt",
  dateOfExit: "Datum Austritt",
  city: "Stadt",
  voucherType: "Gutscheinart",
  sortBy: "Sort by",
  salutation: "Anrede",
  measures: "Maßnahme",
  intermediary: "Vermittler (Internal)",
  lecturer: "Dozent",
  preview: "Vorschau",
  sendReminder: "Mahnung erstellen",
  loading: "Loading.....",
  invalidLink: "Ungültiger Link",
  invalidLinkMessage: "Der Link, den Sie klicken, ist ungültig oder abgelaufen.",
  pleaseFillAllTheFields: "Bitte füllen Sie alle Felder aus",
  pleaseSignTheForm: "Bitte signieren Sie das Formular",
  // Authority
  authority: "Behörde",
  bgNumber: "BG-Nummer",
  team: "Team",
  contactPerson: "Ansprechpartner",
  routingId: "Leitweg-ID (für E-Rechnung)",
  contactEmail: "Ansprechpartner E-mail",
  contactTel: "Ansprechpartner Tel",
  authorityStreet: "Behörde Straße und Hausnummer",
  authorityPostalCode: "Behörde PLZ",
  authorityCity: "Behörde Stadt",
  measure: "Maßnahme",
  intermediary: "Vermittler (Internal)",
  reports: "Reports",

  required: "Dieses Feld ist erforderlich",
  invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  error: "Fehler",
  success: "Erflog",

  settings: "Einstellungen",
  permissionToSignRetroactively: "Erlauben um rückwirkend zu unterschreiben",
  receiveTeachingMaterials: "Lehrnmittel erhalten",
  faceToFaceInstruction: "Präsenzunterricht",
  onlineInstruction: "Onlineunterricht",
  informationForSuccessAndPlacementStatistics: "Angaben für Erfolgs- und Vermittlungsstatistik",
  surveyedAfter6Months: "nach 6 Monaten befragt",
  mediated: "vermittelt",
  saveDetails: "Details speichern",

  street: "Straße",
  streetName: "Straßenname",
  streetNo: "Hausnummer",
  country: "Land",
  pincode: "Postleitzahl",
  userId: "Benutzer-ID",

  examinations: "Prüfungen",
  reportsToTheInsuranceProvider: "Meldungen an den Kostenträger",
  feedbackForm: "Feedbackbogen",
  theParticipantHasNotYetAnsweredAnyFeedbackQuestions: "Der Teilnehmer hat noch keine Feedbackfragen beantwortet!",
  createADischargeReport: "Austrittsmeldung erstellen",
  dischargeReport: "Austrittsmeldung",
  createATerminationReport: "Abbruchsmeldung erstellen",
  terminationReport: "Abbruchsmeldung",
  generatedMessages: "Generierte Meldungen",
  date: "Datum",
  description: "Beschreibung",
  sentTo: "Gesendet an",
  sentOn: "Gesendet am",
  edit: "Bearbeiten",
  examsFrom: "Prüfung von",
  examsTo: "Prüfung bis",
  examType: "Prüfungart",
  registerForExam: "Zur Prüfung eintragen",
  differentInvoiceRecipient: "Abweichender Rechnungsempfänger",
  ifYouWouldLikeToEnterADifferentInvoiceRecipient: 'Wenn Sie einen abweichenden Rechnungsempfänger eintragen möchten, füllen Sie bitte die folgenden Felder aus. Bei der Erstellung der Rechnung oder Mahnung werden die Eingaben in den Feldern "Abweichender Rechnungsempfänger" die Felder des "Kostenträgers" überschreiben.',
  bahrodeCompany: "Behörde / Firma",
  contactPerson: "Ansprechpartner",
  routingId: "Leitweg-ID (für E-Rechnung)",
  invoice: "Rechnung",
  cancelInvoice: "Storno",
  billingEmail: "Rechnung E-mail Adresse",
  streetAndHouseNumber: "Straße und Hausnummer",
  postalCode: "PLZ",
  registeredExamDates: "Eingetragene Prüfungstermine",
  markAsBilled: "als abgerechnet markieren",
  whenWasTheCourseWrittenIHKProfessionalKnowledgeAccordingTo34aTradeRegulationBilled: 'Wann wurde der Kurs: {{courseName}} abgerechnet?',
  examinationFromTo: "Prüfung von - bis",
  typeOfExam: "Prüfungsart",
  examinationResult: "Prüfungsergebnis",
  certificate: "Zertifikat",
  billedOn: "Abgerechnet am",

  houseNumber: "Hausnummer",
  placeOfBirth: "Geburtsort",
  phoneNumber: "Telefon",
  countryOfbirth: "Geburtsland",
  email: "E-mail",
  birthDate: "Geburtsdatum",
  remarks: "Bemerkungen",

  createAttendanceList: "Anwesenheitsliste erstellen",
  dateFrom: "Datum Von",
  dateUntil: "Datum Bis",
  createACertificateOfAbsenceForTheJobCenter: "Bescheinigung der Fehlzeiten für den Kostenträger erstellen",
  createPDF: "PDF erstellen",
  missingSignatures: "Fehlende Unterschriften",
  allSignaturesAreThere: "Alle Unterschriften sind da!",
  updatedOn: "Aktualisiert am",
  updateAttendance: "Anwesenheit aktualisieren",
  missingSignaturesForDays: "Es fehlen Unterschriften für {{count}} Tag(e):",
  missingSignaturesForDaysText: "Es fehlen Unterschriften für",
  markDateAsPresent: "Wollen Sie das Datum {{date}} als anwesend markieren?",
  yesMarkPresent: "Ja, als anwesend markieren",
  reasonsForAbsence: "Fehltagbegründungen",
  certificateFor: "Bescheinigung für",
  dayOfAbsenceFrom: "Fehltag von",
  dayOfAbsenceUntil: "Fehltag bis",
  reason: "Grund",
  noEntriesFound: "Keine Einträge gefunden",
  aMaximumOfFourReasonsForAbsenceCanBeEnteredOnBehalfOfTheParticipantInTheSGBFbWCertificateOfAbsenceDocument: 'Es können maximal 4 Fehltagbegründungen im Namen des Teilnehmers in das Dokument "SGB III - FbW Bescheinigung der Fehlzeiten" in das Feld "Vom Teilnehmenden auszufüllen:" -> "Stellungnahme zu den Fehltagen:" übernommen werden!',
  justifyAbsence: "Fehltag begründen",
  certificatesOfAbsenceIssued: "Erstellte Bescheinigungen der Fehlzeiten",
  fileToDownload: "Datei zum Herunterladen",
  edit: "Bearbeiten",
  createdAttendancePDFs: "Erstellte Anwesenheits PDFs",
  presenceOf: "Anwesenheit von",
  presenceUntil: "Anwesenheit bis",

  insertSickNoteOrDayOfAbsence: "Krankschreibung oder Fehltag einfügen",
  reasonForSickLeaveOrAbsence: "Krankschreibung oder Fehltag begründen",
  reasonsForSickLeaveOrDaysOfAbsenceAreTransferredToTheDocument: 'Begründungen für Krankschreibung oder Fehltage werden in das Dokumen "SGB III - FbW Bescheinigung der Fehlzeiten" in das Feld "Fehlzeiten" -> "Begründung" übernommen!',

  createEInvoices: "E-Rechnungen erstellen",
  invoiceNumber: "Rechnungsnummer",
  invoiceDate: "Rechnungsdatum",
  invoiceAmountInEUR: "Rechnungssumme in EUR",
  invoiceType: "Rechnungsart",
  createInvoices: "E-Rechnungen erstellen",
  rgNumber: "Rg-Nummer",
  rgDate: "Rg-Datum",
  rgSum: "Rg-Summe",
  reminder: "Mahnung",
  reminderAutodispatch: "Mahnung-Autoversand",
  paid: "Bezahlt",
  recordID: "Record ID",
  paidOn: "Bezahlt am",
  unpaid: "Unbezahlt",
  messages: "Nachrichten",
  mr: "Herr",
  mrs: "Frau",
  drivers: "Fahrer",

  eExcused: "E - Entschuldigt",
  ueUnexcused: "UE - Unentschuldigt",
  kIllness: "K - Krank",
  sOther: "S - Andere",
  plz: "PLZ",
  dateOfDeparture: "Datum der Abreise",

  motherTongue: "Muttersprache",
  verhandlungssicher: "Verhandlungssicher",
  veryGood: "Sehr gut",
  good: "Gut",

  shiftSystem: "Schichtsystem (Tag/Nacht/Wochenende)",
  workingHours: "Vollzeit",
  healthRestrictions: "gesundheitliche Einschränkungen",
  furniture: "Mobilität (Öffentliche/Auto)",
  miscellaneous: "Sonstiges",
  yes: "Ja",
  no: "Nein",

  internetEnabledHardware: "Internetfähiges (mit einer Bandbreite von mindestens 1,5 Mbit/s ist empfohlen) Handy, Tablet, Laptop, PC o.ä. (Hardware) vorhanden?",
  b1LevelIsAvailable: "B1 Niveau ist vorhanden",
  jobBoardAccessDataAvailable: "Zugangsdaten Jobbörse vorhanden",
  certificateOfGoodConductWasAvailable: "Führungszeugnis lag vor",
  experienceInTheSecuritySector: "Erfahrungen im Sicherheitsbereich",
  lastEmploymentRelationship: "Letztes Arbeitsverhältnis",
  currentEmploymentRelationship: "Aktuelles Arbeitsverhältnis",

  assessmentOfSuitabilityForFurtherTraining: "Eignungsfeststellung für die Weiterbildung",
  chamberOfIndustryAndCommerceCertifiedSafetySpecialist: '„IHK geprüfte Sicherheitsfachkraft gemäß §34a GewO Online“',
  houseRules: "Hausordnung",
  readCarefully: "(Sorgfältig lesen)",
  order: "Ordnung",
  allRoomsAndFacilitiesAtOurSchoolMustBeMaintainedInOrderAndCleanliness: "In sämtlichen Räumen und Anlagen unserer Schule ist auf Ordnung und Sauberkeit zu achten. Schulräume, Einrichtungen und Anlagen sind sorgfältig zu benutzen. Außerhalb der Unterrichtszeiten dürfen sich Lernende nicht in den Klassenräumen aufhalten. Es ist untersagt, in den Klassenräumen etwas an die Wände zu kleben oder zu schreiben und Schulmöbel in andere Räume zu bringen. Mitarbeitende und Lernende, die Schäden feststellen, melden diese dem Sekretariat.",
  alcoholAndDrugConsumption: "Alkohol- und Drogenkonsum",
  theConsumptionOfAlcohol: "Der Konsum von Alkohol, illegalen Drogen sowie anderen psychoaktiven Substanzen ist auf dem gesamten Schulareal und während schulischer Veranstaltungen (einschließlich aller Pausen) verboten. In Ausnahmefällen kann die Schulleitung den Konsum von Alkohol erlauben.",
  theft: "Diebstahl",
  theftDescription: "Es empfiehlt sich, Wertsachen und Bargeld sorgfältig aufzubewahren. Die Schule stellt den Lernenden und Mitarbeitenden kostenlos Schließfächer zur Verfügung. Für verlorene Schlüssel wird eine Gebühr von Euro 50,- erhoben. Die Schule übernimmt für Diebstähle keine Haftung.",
  parking: "Parkplätze",
  thereAreNoFreeParkingSpacesAvailableOnTheSchoolGrounds: "Auf dem Schulareal stehen keine Gratis-Autoparkplätze zur Verfügung. Fahrräder müssen in den dafür vorgesehenen Fahrradkeller gebracht und abgeschlossen werden. Mopeds und Motorräder sind auf dem Schulareal nicht erlaubt.",
  taskDescription: "Lesen Sie den Text und die Aufgaben 1 bis 4 dazu. Wählen Sie bei jeder Aufgabe die richtige Lösung: a, b oder c. Sie informieren sich über die Hausordnung der BAD Bildungsakademie Deutschland GmbH. Sie nehmen in deren Räumlichkeiten an einem Lehrgang teil.",
  oneAnswerIsCorrect: "Jeweils eine Antwort ist richtig!",

  questionTask2_1: "Was sind die Reaktionen auf Frustration?",
  questionTask2_2: "Welche Anzeichen könnten auf Drogenkonsum hinweisen?",
  questionTask2_3: "Was sollte man beim Umgang mit Gruppen beachten?",
  questionTask2_4: "Was ist ein grundlegendes menschliches Bedürfnis?",
  questionTask2_5: "Welches Verhalten kann man bei betrunkenen Personen erwarten?",
  calmness: "Ruhe",
  contentment: "Zufriedenheit",
  aggression: "Aggression",
  increasedConcentration: "Erhöhte Konzentrationsfähigkeit",
  socialEngagement: "Soziales Engagement",
  dilatedPupils: "Erweiterte Pupillen, Hautverfärbungen",
  easilyProvoked: "Leicht provozierbar",
  formingAlliances: "Bildung von Allianzen mit der Gruppe",
  behavingNeutrally: "Neutrales Verhalten",
  food: "Essen",
  selfActualization: "Selbstverwirklichung",
  friendship: "Freundschaft",

  generalKnowledge: "Allgemeine Wissen",
  questionTask3_1: "Wie hoch ist der Mehrwertsteuersatz in Deutschland?",
  questionTask3_2: "Welche Berufe kann man mit der Sachkundeprüfung nach § 34a GewO ausüben?",
  questionTask3_3: "Wer ist in Deutschland für die Einhaltung des Gesetzes verantwortlich?",
  questionTask3_4: "Wie viele Bundesländer hat Deutschland?",
  questionTask3_5: "Wie heißt der aktuelle Bundeskanzler Deutschlands?",

  cleaner: "Reinigungskraft",
  securityGuard: "Sicherheitsmitarbeiter",
  busDriver: "Busfahrer",
  thePolice: "Die Polizei",
  theCourts: "Die Gerichte",
  theSecurityServices: "Die Sicherheitsdienste",
  answer5: "5",
  answer16: "16",
  answer23: "23",
  msMerkel: "Frau Merkel",
  mrAdenauer: "Herr Adenauer",
  mrScholz: "Herr Scholz",
  hamburg: "Hamburg",
  munich: "München",
  berlin: "Berlin",
  signature: "Unterschrift",
  plz: "PLZ",

  ifNoThisWillBeRequestedBeforeTheStartOfTheMeasureAndSubmitted: "Wenn Nein -> wird vor Maßnahme Beginn beantragt und der BAD Bildungsakademie Deutschland GmbH vorgelegt. Danach Kann die Maßnahme erst begonnen werden, wenn keine relevanten Einträge vorhanden sind. Dies habe ich zur Kenntnis genommen und bestätige ich.",
  applicantSignature: "Unterschrift des Bewerbers",
  yesHerebyConfirm: "ja -> hiermit wird bestätigt, dass mir durchaus bewusst ist, dass die Maßnahme in Vollzeit stattfindet. Ich traue mir zu, dies parallel zu absolvieren.",
  herebyConfirmCompleteness: "Hiermit bestätige ich die Vollständigkeit und Richtigkeit der oben genannten Angaben und erkläre mich damit einverstanden, dass die BAD Bildungsakademie Deutschland GmbH, meine persönlichen Daten bis auf Wiederruf in Ihrem System speichern darf.",

  NameOfTheClerkAndDate: "Name des Kassierers und Datum",
  certificateOfGoodConductWasAvailable: "Führungszeugnis lag vor",
  relevantEntry: "Relevant Eintrag",
  notRelevantEntry: "Nicht relevanter Eintrag",
  noEntry: "Kein Eintrag",
  certificateOfGoodConductWasNotAvailable: "Zugang zum Zertifikat der guten Verhaltensweise nicht verfügbar:",
  remarksNotesFromTheClerkDuringTheInterview: "Bemerkungen/Notizen des Kassierers während der Interview:",
  willBeSubmittedOn: "Wird am:",
  reminderSet: "Erinnerung gesetzt (Outlook, Mobil, andere)",

  allMeasures: "alle Maßnahmen",
  showEvaluation: "Auswertung anzeigen",
  createdFeedbackEvaluations: "Erstellter Feedbackbogen-Auswertungen",
  feedbackEvaluation: "Feedbackbogen-Auswertung",
  successAndPlacementStatistics: "Erfolgs- und Vermittlungsstatistik",
  createdSuccessAndPlacementStatistics: "Erstellte Erfolgs-und Vermittlungsstatistik-Answertungen",
  qualificationPlanCreate: "Qualifizierungsplan Erstellen",
  createdQualificationPlans: "Erstellte Qualifizierungsplane",

  German: "Deutsch",
  English: "Englisch",
  French: "Französisch",
  Turkish: "Türkisch",
  Arabic: "Arabisch",
  Other: "Andere",
  interestedInMeasure: "An welcher Maßnahme ist der Teilnehmer interessiert:",
  dataCollectionForm: "Erfassungsbogen",
  basicKnowledge: "Grundkenntnisse",

  fromTime: "Zeit Von",
  toTime: "Zeit Bis",
  photo: "Foto",
  duration: "Zeit",
  hour: "Uhr",
  to: "bis",

  // Results Sheet
  carrierOfTheMeasure: "Trager der Maßnahme",
  nameOfTheMeasure: "Bezeichnung der Maßnahme",
  measureNumber: "Maßnahme-Nummer",
  contactPersonInclTel: "Ansprechpartner/in (inkl. Tel.Nr.)",
  nameFirstName: "Name, Vorname",
  placeOfResidence: "(Wohnort-) Agentur fur Arbeit / Jobcenter",
  orgNumber: "Org.zeichen / Kundennummer",
  referenceNumber: "Referenznummer Bewerberprofil",
  finalInvoice: "Schlussrechnung",
  rate: "Rate",
  expertKnowledge: "Experten-Kenntnisse",
  advancedKnowledge: "Erweiterte-Kenntnisse",
  basicKnowledge: "Grund-Kenntnisse",
  willingnessToBeMobile: "Mobilitatsbereitschaft",
  acrossTheCountry: "bundesweit",
  international: "international",
  maxPendelTime: "max. Pendelzeit (gesamt)",
  regionalWishes: "Regionale Wunsche",
  from: "Von",
  to: "Bis",
  at: "Bei",
  activity: "Tatigkeit als",
  applicationTo: "Bewerbung bei",
  participant: "Teilnehmer",
  resultOpen: "Ergebnis Offen",
  cancellation: "Absage",
  dateOfTheParticipant: "Datum (Teilnehmer)",
  trainingSupportCreated: "Erstellte Förderung der beruflichen Weiterbildung Ergebnisbogen",

  participantId: "Teilnehmer-ID",
  attendanceInTheMorning: "Anwesenheit vormittags",
  attendanceInTheAfternoon: "Anwesenheit nachmittags",

  documents: "Dokumente",
  fileDescription: "Datei - Beschreibung",
  fileUpload: "Datei zum hochladen",
  uploadedFiles: "Hochgeladene Dateien",
  certificates: "Zertifikate",
  certificateOfTheCarrier: "Tragerzertifikat generieren",
  generatedMessages: "Generierte Meldungen",
  createdFeedbackForms: "Erstellter Feedbackbogen",
  createdCertificatesOfAbsences: "Erstellte Bescheinigungen der Fehlzeiten",
  certificatesOfAbsences: "Bescheinigungen der Fehlzeiten",
  createdInvoices: "Erstellte Rechnungen",
  createdProfessionalDevelopmentFundingRequestResultsSheet: "Erstellte Forderung der beruflichen Weiterbildung Ergebnisbogen",
  trainingReportsOfTheParticipant: "Schulungsreports des Teilnehmers",
  updatedOn: "Aktualisierrt am",
  attendanceDate: "Anwesenheit Datum",
  willBeDisplayedFrom1300: "Wird ab 13:00 angezeigt",
  willBeDisplayedFrom0900: "Wird ab 09:00 angezeigt",
  weekend: "Wochenende",
  holiday: "Feiertag",
  daysUntilReminderNotice: "{{count}} Tage bis zur Mahnung",
  joiningDate: "Datum Eintritt",
  examResult: "Ergebnis",
  passed: "Bestanden",
  failed: "Nicht bestanden",
  markAsBilled: "als abgerechnet markieren",

  active: "Aktiv",
  inactive: "Inaktiv",
  pending: "Pending",
  assessment: "Fazit",
  finalAssessment: "Abschlussbewertung",
  interimAssessment: "Zwischenbewertung",
  dateBetweenReview: "Datum Zwischenfazit",
  participantName: "Name Teilnehmer",
  lecturer: "Dozent/in",
  courseDuration: "Kursdauer",
  largestSuccessExperience: "Größtes Erfolgserlebnis",
  personalDevelopment: "Persönliche Entwicklung",
  largestChallenge: "Größte Herausforderung",
  oralParticipation: "Mündliche Mitarbeit",
  writtenPerformance: "Schriftliche Leistungen",
  handlingLearningProblems: "Umgang mit Lernproblemen",
  developmentOfWeakerSubjectAreas: "Entwicklung schwächerer Themenbereiche",
  usageOfSupportServices: "Nutzung von Hilfen und Unterstützungsangeboten",
  overallJudgment: "Gesamturteil",
  lecturerSignature: "Unterschrift Dozent/in",
  participantSignature: "Unterschrift Teilnehmer/in",
  learningStand: "Lernstand",
  ratingByLecturer: "Bewertung durch den Dozenten",
  testResults: "Ergebnisse der Tests",
  lecturerRating: "Bewertung Dozent",
  absences: "Fehlzeiten",
  currentLearningProgress: "Aktueller Lernfortschritt",
  isTheSuccessOfTheMeasureThreatened: "Ist der Erfolg der Maßnahme gefährdet?",
  supportMeasuresTakenToSupportTheParticipant: "Welche Hilfestellung oder Maßnahmen wurden ergriffen um den TN zu unterstützen / fördern...",
  pdfName: "PDF-Dateiname",
  documentUpload: "Dokument hochladen",
  fileName: "Datei Name",
  remarks_student: "Bemerkung",

  addLiveWebinar: "Live-Webinar hinzufügen",
  webinarLink: "Webinar Link",
  title: "Titel",
  messages: "Meldungen",
  daysMessageAttendance: "{{count}} Fehltage",
  name: "Name",
}

export default {
  common: {
    totalLicenses: "Gesamtlizenzen",
    changedEndDate: "Enddatum geändert",
    yearlyLogs: "Jahresprotokolle",
    generateLogs: "Protokolle generieren",
    fridaySheet: "Freitagsprüfung",
    fridaySheetTitle: "Sachkunde 34a- Deine Freitagsprüfung",
    selectedAnswer: "Ausgewählte Antwort",
    correctAnswer: "Richtige Antwort",
    studentAbsences: "Abwesenheiten von Studenten",
    examSheetSuccessTitle: "PRÜFUNG BESTANDEN",
    examSheetNotPassed: "NICHT BESTANDEN",

    examSheetSuccessDescription: "Deine Punktzahl :",
    pass: "Bestanden",
    points: "Punkte",
    failed: "Nicht Bestanden",
    subjectKnowledge34aSimulation: "Sachkunde 34a – Prüfungssimulation",
    expertiseSection34aExercisesForTheOralExamination: "Sachkunde §34a – Übungen für die mündliche Prüfung",
    examMode: "Prüfungsmodus",
    practiceMode: "Übungsmodus (Learnmode)",
    subjectKnowledge34aPractice: "Sachkunde 34a – Übungen für die schriftliche Prüfung",
    examination: "Prüfung",
    pleaseAdd: "Bitte hinzufügen",
    search: "Suche",
    clearAll: "Alle löschen",
    applyFilter: "Filter anwenden",
    pleaseEnter: "Bitte eingeben",
    pleaseSelect: "Bitte auswählen",
    addNewUser: "Neuen Benutzer hinzufügen",
    addNewUserLessDetails: "Mitarbeiter hinzufügen",
    editUser: "Benutzer bearbeiten",
    rowsPerPage: "Zeilen pro Seite",
    displaying: "Anzeigen {from} bis {to} von {total} Einträgen",
    previous: "Vorherige",
    next: "Nächste",
    all: "Alle",
    page: "Seite",
    of: "von",
    goToPage: "Gehe zu Seite",
    first: "Erste",
    last: "Letzte",
    active: "Aktiv",
    inactive: "Inaktiv",
    send: "Senden",
    updateAndRegeneratePDF: "Aktualisieren und PDF neu generieren",
    save: "Speichern",
    yes: "Ja",
    no: "Nein",
    number_no: "Nr.",
    back: "Zurück",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    setUpPassword: "Passwort einrichten",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    saveChanges: "Änderungen speichern",
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    invalidPassword: "Das Passwort muss mindestens 8 Zeichen lang sein",
    confirmPasswordError: "Passwörter stimmen nicht überein",
    noDataFound: "Keine Daten gefunden",
    date: "Datum",
    ID: "ID",
    actions: "Aktionen",
    participantData: "Teilnehmerdaten",
    contactDetails: "Kontaktdaten",
    attendance: "Anwesenheit",
    sickNotes: "Krankschreibungen/Abwesenheiten",
    invoices: "Rechnungen",
    resultsSheet: "Ergebnissheet",
    learningProgress: "Lernfortschritt",
    documents: "Dokumente",
    invalid: "Bitte geben Sie eine gültige Information ein",
    invalidPhoneNumber: "Ungültige Telefonnummer",
    areYouSureYouWantToProceed: "Sind Sie sicher, dass Sie fortfahren möchten?",
    confirmation: "Bestätigung",

    task: "Aufgabe",
    tasks: "Aufgaben",
    students: "Schüler...",
    theFollowingAppliesToTheClassroomsOfBADBildungsakademieDeutschlandGmbH: "Die folgenden Bedingungen gelten für die Räume der BAD Bildungsakademie Deutschland GmbH:",
    toUseTheLockableLockersYouMust: "Um das Schließfach zu nutzen, muss...",
    drinkingAlcohol: "Alkohol...",
    areNotAllowedToBringBicyclesToSchool: "Es ist nicht erlaubt, Fahrräder zur Schule zu bringen.",
    areAllowedToLeaveTheirBicyclesInTheSchoolyard: "Es ist erlaubt, ihre Fahrräder im Schulgarten zu lassen.",
    mustLeaveTheirBicyclesInASpecialRoom: "Sie müssen ihre Fahrräder in einem besonderen Raum lassen.",
    studentsAreNotPermittedToHangPosters: "Schüler dürfen keine Plakate aufhängen.",
    studentsMustCleanUpAfterClass: "Schüler müssen nach dem Unterricht aufräumen.",
    studentsMayStudyThereAfterClass: "Schüler können dort nach dem Unterricht lernen.",
    requestAKeyFromTheOffice: "Fordern Sie einen Schlüssel beim Büro an.",
    payAOneTimeFeeOf50: "Zahlen Sie eine einmalige Gebühr von €50.",
    beAStudentOrWorkAt: "Muss Schüler sein oder bei der BAD Bildungsakademie Deutschland GmbH arbeiten.",
    mayBeApprovedByTheSchoolAdministration: "Kann von der Schulverwaltung genehmigt werden.",
    mustBeReportedToTheTeacher: "Muss dem Lehrer gemeldet werden.",
    isStrictlyProhibited: "Ist strengstens untersagt.",
    sampleQuestionsFromAnIHKExpertKnowledgeExamination: "Beispielfragen aus einer IHK Expertenwissenprüfung §34a gemäß GewO",
    messageForFileUploadLimit: "Message : Die hochgeladene Datei darf 5 MB nicht überschreiten, und das unterstützte Dateiformat ist PDF.",
    userInformation: "Benutzerinformation",
    savePDF: "als PDF speichern"
  },
  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    username: "E-Mail",
    password: "Password",
    rememberMe: "Angemeldet bleiben",
    forgotPassword: "Passwort vergessen?",
    welcomeMessage: "Geben Sie Ihre Anmeldedaten ein und genießen Sie unsere Kurse",
    usernamePlaceholder: "Geben Sie Ihre E-Mail ein",
    passwordPlaceholder: "Geben Sie Ihr Password ein",
    welcomeMessage1: "Sehr gute Arbeiten sind",
    welcomeMessage2: "auf Sie wartend",
    welcomeMessage3: "Jetzt anmelden"
  },
  sidebar: {
    main: "HAUPTSEITE",
    others: "ANDERE",
    dashboard: "Dashboard",
    users: "Benutzer",
    participants: "Teilnehmer",
    documents: "Dokumente",
    attendance: "Anwesenheit",
    settings: "Einstellungen",
    carrier: "Träger",
    notifications: "Benachrichtigungen",
    logout: "Abmelden",
    students: "Teilnehmer",
    measurement: "Maßnahmen",
    intermediary: "Vermittler (Internal)",
    examinations: "Prüfungen",
    bridgeDays: "Brückentage",
    lecturers: "Dozenten",
    qualificationPlan: "Qualifizierungsplan",
    documents: "Dokumente",
    missingSignatures: "Fehlende Unterschriften",
    liveAttendance: "Live-Anwesenheit",
    organization: "Organigramm",
    qualificationMatrix: "Qualifikationsmatrix",
    trainingReports: "Schulungsreports",
    liveWebinar: "Live-Webinar",
    studentsLogs: "Teilnehmerprotokolle",
    stundenplan: "Stundenplan",
  },
  stundenplan: {
    title: "Stundenplan",
    addCourseLabel: "Neuen 3-Monatskurs hinzufügen",
    trainer: "Dozent",
    startDate: "Startdatum",
    addButton: "Kurs hinzufügen",
    addSuccess: "Kurs erfolgreich hinzugefügt. Der Stundenplan wird neu geladen.",
    addError: "Fehler beim Hinzufügen des Kurses.",
    loadError: "Dozentenliste konnte nicht geladen werden.",
  },
  header: {
    welcome: "Willkommen zurück",
    search: "Hier suchen",
    language: "Sprache",
    english: "Englisch",
    german: "Deutsch"
  },
  users: {
    title: "Benutzer",
    list: "Benutzerliste",
    add: "Neuen Benutzer hinzufügen",
    edit: "Benutzer bearbeiten",
    delete: "Benutzer löschen",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    cancel: "Abbrechen",
    save: "Speichern",
    search: "Benutzer suchen",
    table: {
      id: "ID",
      name: "Name",
      email: "E-Mail",
      address: "Anschrift",
      status: "Status",
      action: "Aktion",
      userName: "Benutzername",
      firstName: "Vorname",
      lastName: "Nachname",
      phoneNumber: "Telefonnummer",
      dateOfBirth: "Geburtsdatum",
      zipCode: "Postleitzahl",
      placeOfBirth: "Geburtsort",
      countryOfbirth: "Geburtsland",
      telephone: "Telefon",
      city: "Stadt"
    },
    form: {
      userName: "Benutzername",
      firstName: "Vorname",
      lastName: "Nachname",
      phoneNumber: "Telefonnummer",
      email: "E-Mail",
      address: "Anschrift",
      status: "Status",
      password: "Password",
      confirmPassword: "Passwort bestätigen"
    },
    validation: {
      required: "Dieses Feld ist erforderlich",
      email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      password: "Das Password muss mindestens 8 Zeichen lang sein",
      confirmPassword: "Passwörter stimmen nicht überein"
    }
  },
  searchFilter: {
    search: "Suchfilter"
  },
  home: {
    cards: {
      totalStudents: "Gesamtzahl der Studenten",
      totalTeachers: "Gesamtzahl der Lehrer",
      totalEmployee: "Gesamtzahl der Mitarbeiter",
      totalCourses: "Gesamtzahl der Kurse"
    },
    charts: {
      attendance: "Teilnahme Diagramm",
      totalStudents: "Gesamtzahl der Studenten",
      activeInactiveStudents: 'Aktive/Inaktive Studenten',
      activeStudents: 'Aktive Studenten',
      inactiveStudents: 'Inaktive Studenten',
      byGender: "nach Geschlecht",
      boys: "Jungen",
      girls: "Mädchen",
      thisWeek: "Diese Woche",
      lastWeek: "Letzte Woche",
      thisMonth: "Diesen Monat",
      present: "Gesamtzahl der Anwesenden",
      absent: "Gesamtzahl der Abwesenden",
      sick: "Gesamtzahl der Kranken"
    }
  },
  students: {
    studentsList: "Teilnehmer Liste",
    add: "Neuen Teilnehmer hinzufügen",
    edit: "Teilnehmer bearbeiten",
    delete: "Teilnehmer löschen",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Teilnehmer löschen möchten?",
    cancel: "Abbrechen",
    save: "Speichern",
    participantData: "Teilnehmerdaten"
  },
  measurement: {
    addNewMeasurement: "Neue Maßnahme erstellen",
    measurementList: "Maßnahmen Liste",
    measurements: "Maßnahme",
    no: "Nr.",
    measuresNumber: "Maßnahmen Nummer",
    measuresTitle: "Maßnahmen Titel",
    months: "Monate",
    showInDocuments: "In Unterlagen anzeigen",
    edit: "Bearbeiten",
    accordingToParagraph: "Nach Paragraph",
    measureEdit: "Maßnahmen bearbeiten",
    createNewMeasurement: "Neue Maßnahme erstellen",
    measure: "Maßnahmen",
    registeredForTheMeasureAre: "Zur Maßnahme angemeldet sind"
  },
  intermediary: {
    insertNewAgent: "Neuen Vermittler einfügen",
    intermediary: "Vermittler",
    addNewIntermediary: "Neuen Vermittler einfügen",
    agentEmail: "Vermittler email",
    agentTel: "Vermittler Tel",
    eMustermannMustermann: "(z.B: Max Mustermann oder Herr Musterman)",
    intermediaryParticipant: "Vermittelte Teilnehmer",
    agentsBearbetten: "Vermittler Bearbetten"
  },
  examinations: {
    examinations: "Prüfungen",
    insertNewTest: "Neue Prüfung einfügen",
    test: "Prüfung",
    addNewTest: "Neue Prüfung einfügen",
    examinationTitle: "Prüfungsbezeichnung"
  },
  bridgeDays: {
    bridgeDays: "Brückentag",
    addNewBridgeDay: "Brückentag einfügen",
    bridgeDayList: "Brückentag Liste",
    bridgeDay: "Brückentag",
    insertBridgeDays: "Brückentag erstellen"
  },
  documents: {
    assessmentOfSuitability: "Zur Eignungsbewertung",
    dataCollectionForm: "Erfassungsbogen",
    generateLink: "Link generieren",
    generatedLink: "Generierter Link",
    createNewUrlForSuitabilityAssessment: "Neue URL für Eignungsbewertung erstellen",
    createNewUrlForDataEntryForm: "Neue URL für Datensammlungsformular erstellen",
    YouCanEditTheRegistrationFormAtAnyTime: "Sie können die Registrierungsformular jederzeit bearbeiten.",
    clickGenerateLink: 'Klicken Sie auf den "Link generieren"-Button, um eine benutzerdefinierte URL zu generieren, die Sie an Ihren Kunden senden können.',
    clickCopy: 'Klicken Sie auf den "Link kopieren"-Button, um die URL in Ihre Zwischenablage zu speichern.',
    youCanNowSendTheLink: 'Sie können jetzt die Link an Ihren Kunden in jeder Art senden, via WhatsApp oder E-Mail.',
    linkIsValidFor8Days: "Die URL ist für 8 Tage gültig. Wenn Ihr Kunde die Eignungsbewertung innerhalb von 8 Tagen nicht abschließt, wird diese URL aus dem System gelöscht.",
    youCanGenerateAsManyLinksAsYouLike: "Sie können so viele Links wie Sie möchten generieren.",
    createdUrls: "Erzeugte URLs",
    linkDate: "Linkdatum",
    measuresTitle: "Maßnahmenüberschriften",
    firstName: "Vorname",
    lastName: "Nachname",
    dateSignature: "Datum, Unterschrift",
    comment: "Kommentar",
    aptitudeAssessmentFrom: "Eignungsbewertung von",
    commentsNotes: "Bemerkungen",
    updateAndRegeneratePdf: "Aktualisieren und erneut generieren",
    notYetSigned: "Noch nicht unterschrieben! Diese URL wird automatisch in 8 Tagen gelöscht.",
    copy: "Kopieren",
    dataCollectionForm: "Erfassungsbogen",
    whichMeasureIsTheParticipantInterestedIn: "Welche Maßnahme interessiert den Teilnehmer?",
    specialKnowledge: "Besondere Kenntnisse",
    languages: "Sprachen",
    wordAndWriting: "Wort und Schrift",
    personalSuitability: "Persönliche Eignung",
    professionalSuitability: "Fachliche Eignung",
    professionalInformation: "Berufliche Informationen",
    assessmentOfConsultation: "Bewertung der Beratung (Maßnahmeziel erreicht)",
    notesRecommendations: "Bemerkungen/empfohlene Maßnahmen Bildungsakademie Deutschland GmbH:"
  },
  lecturers: {
    lecturersList: "Dozentenliste",
    addNewLecturer: "Neuen Dozenten hinzufügen",
    lecturer: "Dozent",
    measure: "Maßnahme",
    certificates: "Qualifikationsnachweise / Zertifikate"
  },
  resultsSheet: {
    applicationForProfessionalDevelopmentFundingResultsSheet: "Forderung der berufliuchen Weiterbildung Ergebnisbogen / Bewerberprofil",
    participant: "Teilnehmer/in",
    skillsKnowledgeAbilities: "Fertigkeiten, Kenntnisse und Fahigkeiten (primar im Rahmen der Maßnahme erworben)",
    skillsKnowledgeAbilitiesNote: "Nutzen Sie hierzu auch die im Internet unter: ",
    skillsKnowledgeAbilitiesNoteText: "BERUFENET - “Berufsbezeichnung” - Tatigkeit - Kompetenzen hinterlegten Berufsbeschreibungen. Bitte erganzen Sie diese Liste bei Bedarf auf einer anderen Seite! Die Angaben dienen auch zur Uberarbeitung des Bewerberprofils in der Jobborse. ",
    YouCanAlsoMakeTheRevisionDirectlyInTheJobPortal: "Sie konnen die Uberarbeitung auch direkt in der Jobborse vornehmen!",
    YouCanAlsoMakeTheRevisionDirectlyInTheJobPortalNote: "Dazu benotigen Sie Ihre Zugangsdaten und schreibenden Zugriff auf Ihre Fahigkeiten, Sllten Sie nicht daruber verfugen, sprechen Sie Ihren Betreuer darauf an.",
    skillsKnowledgeAbilitiesAttention: "Fertigkeiten, Kenntnisse und Fahigkeiten Achtung!!!",
    skillsKnowledgeAbilitiesAttentionNote: "Eintrage fur Sachkunde, Ersthelder und Waffensachkunde werden automatisch eingetrtagen sobald die jeweilige “Prufung” unter Teilnehmerdaten erstelt wird!",
    itSkills: "IT Kenntnisse",
    itSkillsNote: "(z.B. Office-, Grafikprogramme, Branchensoftware, Programmierung)",
    languageSkills: "Sprachkenntnisse",
    mobility: "Mobilitat",
    mobilityNote: "(nach Ende der Mabnahme)",
    internship: "Praktikum",
    internshipNote: "(nur ausfullen bei Mabnahmen mit Praktikum)",
    mobilityReadiness: "Mobilitatsbereitschaft",
    internshipDuringMeasure: "Praktikum wahrend der Mabnahme",
    employmentBehavior: "Bewerbungsverhalten",
    jobApplicationActivitiesDuringTheMeasure: "Bewerbungsaktivitaten wahrend der Mabnahme",
    possiblyAttachmentInListForm: "(ggf. Anhang in Listenform)",
    futureJobApplicationActivities: "Zukunftige Bewerbungsaktivitaten erstrecken sich auf folgende Berufe / Tatigkeiten",
    futureJobApplicationActivitiesNote: "(Mit Ihren Zugangsdaten fur die Jobborse konnen Sie diese auch direkt in ein neues Stellengesuch eintragen!)",
    alternativesIndustryTemporary: "Alternativen (z.B. Branche, Zeitarbeit,Selbstandigkeit)",
    otherNotes: "Sonstige Anmerkungen",
    otherNotesNote: "(z. B. Erganzungen und weitere Informationen, die im Rahmen der Mabnahme-durchfuhrung erhoben wurden, z. b.Aktualitat/Anerkennung von Zertifizierungen)",
    participantSignature: "Unterschrift Teilnehmer"
  },
  learningProgress: {
    learningProgress: "Lernfortschritt",
    subjectKnowledge32a: "Sachkunde 34a - Videolektionen in deutscher Sprache",
    courseStarted: "Kursangefangen arm",
    lastVisit: "Letzter Besuch",
    certificate: "Zertifikat",
    title: "Titel",
    error: "Fehler",
    points: "Punkte",
    firstAidPreparation: "Ersthelfer Vorbereitung (BB)",
    firePrevention: "Bransschutz & Evakuierungshelfer gemaB10ArbSchG (BB)",
    examinationsAndTests: "Prufungen und Tests",
    firearmsPreparation: "Waffensachkundevorbereitung gem. 7 WaffG  (BB)",
    subjectKnowledge34a: "Sachkunde34a - Ubungen fur die schriftliche Prufung",
    subjectKnowledge34aTest: "Sachkunde 34a - Probeprufungen"
  },
  traininginsert: {
    trainingInsert: "Weiterbildung einfügen",
    trainingTopic: "Schulungsthema",
    quarter: "Quartal",
    year: "Jahr",
    actualDate: "Tatsächliches Datum",
    participation: "Teilnahme",
    reasonForNonParticipation: "Gründe für Nichtteilnahme",
    feedback: "Feedback / Teilnahmeauswertung",
    effectiveness: "Wirksamkeit",
    registeredTrainings: "Eingetragene Weiterbildungen",
    timePeriod: "Zeitraum",
    planned: "Geplant",
    actual: "Tatsächlich",
    effectivenessAZAV: "Wirksamkeit nach AZAV",
    invoiceStatus: "Rechnungsstatus",
  },
  position: {
    positionTitle: "Posten",
    positionTitlePlaceholder: "(z.B: Geschäftsführer)",
    internalExternal: "Intern / extern",
    internal: "intern",
    external: "extern",
    responsibilityAndAuthority: "Verantwortung und Befugnisse",
    hierarchicalAssignedTo: "Hierarchisch zugeordnet zu"
  },
  exitreportcreate: {
    exitReportCreate: "Austrittsmeldung erstellen",
    measureEndedByExam: "Die Maßnahme wurde durch vorzeitige Prüfung / erfolgreiche Teilnahme beendet",
    firstAttendanceDay: "erster persönlicher Anwesenheitstag",
    lastAttendanceDay: "letzter persönlicher Anwesenheitstag",
    examFailed: "Die Prüfung wurde nicht bestanden",
    no: "Nein",
    create: "erstellen"
  },
  withdrawalreportcreate: {
    withdrawalReportCreate: "Abbruchsmeldung erstellen",
    participationTerminated: "Die Teilnahme an der Maßnahme wurde abgebrochen",
    firstAttendanceDay: "erster persönlicher Anwesenheitstag",
    lastAttendanceDay: "letzter persönlicher Anwesenheitstag",
    terminationReason: "Die Maßnahme wurde abgebrochen wegen:",
    employment: "Arbeitsaufnahme",
    employmentFrom: "Arbeitsaufnahme zum:",
    insufficientPerformance: "mangelnder Leistung",
    longAbsences: "längerer Fehlzeiten",
    otherReasons: "sonstiger Gründe",
    reasons: "Gründe",
    no: "Nein",
    create: "erstellen"
  },
  carrier_documents: {
    documents: "Dokumente",
    feedbackEvaluations: "Erstellte Feedbackbogen-Auswertungen",
    date: "Datum",
    description: "Beschreibung",
    downloadFile: "Datei zum Herunterladen",
    feedbackDescription: "Feedback-Auswertung 01.01.2024 - 06.06.2024",
    successStatistics: "Erstellte Erfolgs - und Vermittlungsstatistik - Auswertungen",
    successDescription: "Erfolgsstatistik 2024 - 955/234/2023",
    qualificationPlans: "Erstellte Qualifizierungspläne",
    qualificationDescription: "Qualifizierungsplan 2024 -2024",
    organizationChart: "Erstellte Organigramm",
    qualificationsMatrix: "Erstellte Qualifikationsmatrix",
    qualificationsMatrixDescription: "Qualifizierungsmatrix",
    trainingReports: "Schulungsreports je Dozent",
    noData: "-"
  },
  liveattendance: {
    updateValues: "Werte aktualisieren",
    importantNote: "Wichtiger Hinweis",
    importantNoteText: "Die Anzeige beziet sich ausschlieblich auf die Logins in unserem Lenportal! Derzeit konnen wir die Anwesenheit in den Zoom-Raumen leider nicht darstellen.",
    attendanceList: "Anwesenheit List",
    stampSet: "Der Stempel wurde gesetzt",
    TNWillAbbrechenStatus: "TN will abbrechen Status :",
    NoLoginAttemptInTheMorning: "Kein Loginversuch am Vormittag",
    NoLoginAttemptInTheAfternoon: "Kein Loginversuch am Nachmittag",
    WillBeDisplayedFrom100PM: "Wird ab 13:00 Uhr angezeigt",
    LastLoginAt: "Letzter Login um 09:41 Uhr",
  },
  missingSignatures: {
    missingSignatures: "Fehlende Unterschriften",
    missingSignaturesList: "Fehlende Unterschriften List",
    missingSignaturesText: "Es fehlen Unterschriften fur 4 Tage :",
    updatedOn: "Aktualisierrt am",
    carrier: "Vermittler",
    intermediary: "Vermittler"
  },
  days: {
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag"
  },
  vocationalTraining: {
    questionnaireForParticipantsInVocationalTrainingPrograms: "Fragebogen für Teilnehmerinnen und Teilnehmer an beruflichen Weiterbildungsmaßnahmen",
    vocationalTraining: "Sie nehmen derzeit an einer beruflichen Weiterbildungsmaßnahme teil. Für die Bundesagentur für Arbeit ist es wichtig zu wissen, welche Erfahrungen Sie mit dieser Maßnahme gemacht haben. Ihre Aussagen können weiterhelfen, die Qualität der beruflichen Weiterbildung zu verbessern.",
    youWillBeAskedToEvaluateTheTrainingProgram: "Im Folgenden werden Sie um eine Beurteilung der von Ihnen besuchten Weiterbildungsmaßnahme gebeten.",
    privacy: "Ihre Angaben werden selbstverständlich anonym (ohne Namen) ausgewertet;",
    privacyNote: "Rückschlüsse auf Ihre Person sind nicht möglich, so dass Ihnen auch keine Nachteile aufgrund Ihrer Angaben entstehen.",
    note: "Wenn Sie auf den Smiley oder die Antwortoption klicken, wird Ihre Antwort sofort gespeichert und erscheint nicht mehr in der Liste!",
    programTitle: "Bezeichnung der Weiterbildungsmaßnahme",
    providerTitle: "Bildungsträger/-einrichtung",
    numberTitle: "Maßnahme-Nummer",
    status: "Es sind noch 21 von 21 Fragen zu beantworten!",
    q1: "Die vorhandenen Räumlichkeiten (Unterrichts- und Arbeitsräume, Werkstätten, Pausenräume, sanitäre Anlagen) sind in ordnungsgemäßem Zustand.",
    q2: "Eine ausreichende technische Ausstattung (PC, Maschinen, Werkzeuge) ist vorhanden.) sind in ordnungsgemäßem Zustand.",
    q3: "Lehr- und Lernmittel (z.B. Arbeitskleidung, Bücher, Skripte, Arbeitsblätter) stehen zur Verfügung.",
    q4: "Die Ausbilder/innen und Lehrkräfte vermitteln die Lehrgangsinhalte verständlich",
    q5: "Die Ausbilder/innen und Lehrkräfte gehen im Unterricht auf die Teilnehmer/innen ein und unterstützen sie",
    q6: "Die Ausbilder/innen und Lehrkräfte geben Rückmeldungen zum jeweiligen Leistungsstand.",
    q7: "Mitarbeiter/innen der Bildungseinrichtung unterstützen die Teilnehmer/innen bei persönlichen Schwierigkeiten.",
    q8: "Mitarbeiter/innen der Bildungseinrichtung unterstützen die Teilnehmer/innen bei der Suche nach einem geeigneten Arbeitsplatz.",
    q9: "Vor Lehrgangsbeginn erfolgte eine ausreichende Information über Inhalte und (zeitlichen) Ablauf.",
    q10: "Die Bildungseinrichtung hat mit mir einen Schulungsvertrag abgeschlossen, der wesentliche Angaben zur Qualifizierung enthält (z.B. Qualifizierungsinhalte, Praktikazeiten, Angaben zu Lernmitteln und Arbeitskleidung, Rücktritts- und Kündigungsmodalitäten).",
    q11: "Die Teilnehmer des Lehrgangs passen hinsichtlich ihrer Berufsausbildung bzw. ihren Vorkenntnissen gut zusammen.",
    q12: "Die Lehrgangsinhalte / der vermittelte Lehrstoff entsprechen meinen Vorkennt-nissen und Erwartungen.",
    q13: "Die Lehrstoff wird verständlich vermittelt.",
    q14: "Der Unterricht ist so ausgestaltet, dass mir gentigend Zeit bleibt, das Erlernte zu verarbeiten und zu verfestigen.",
    q15: "Der Lehrgang ist gut organisiert (z.B. hinsichtlich rechtzeitiger und umfassender ereitstellung von Stundenplänen, Pausenregelungen, Ubungs-möglichkeiten).",
    q16: "Im Lehrgang werden unterschiedliche Medien eingesetzt (z.B. Flip-Chart, Unterrichtsfolien, Beamer, Filme, interaktive Medien).",
    q17: "Es gibt regelmäßig Lernerfolgskontrollen (z.B. Klassenarbeiten, Tests, praktische Aufgaben).",
    q18: "Bei Ausfall von Lehrkräften / Ausbilder/innen ist eine Vertretung sichergestellt.",
    q19: "Welche der genannten Aussagen trifit bei der Beurteilung der Qualifizierungs-maßnahmen Ihrer Meinung nach am ehesten zu?",
    q20: "Die Dauer der Qualifizierungsmaßnahme ist nach meiner jetzigen Einschätzung für mich insgesamt ..",
    q21: "Insgesamt bin ich mit der Qualfizierungsmaßnahme zufrieden oder nicht zufrieden?",
    satisfied: "Zufrieden",
    notSatisfied: "Nicht zufrieden",
    neutral: "Neutral",
    questions: "Fragen",
    justRight: "gerade richtig",
    tooShort: "zu kurz",
    partial: "zum Teil",
    tooLong: "zu lang",
    canSayYet: "kann ich noch nicht sagen",
    helpful: "Die Qualifizierung hilft mir, leichter einen Arbeitsplatz zu finden",
    unchanged: "Meine Chancen auf einen Arbeitsplatz haben sich nicht verändert",
    worse: "Ich habe nur Zeit verloren, meine Chancen auf einen Arbeitsplatz sind schlechter geworden",
    unknown: "Ich kann jetzt noch nicht sagen, ob sich etwas verändert",
    noteAndRemark: "Hinweise und Anmerkungen",
    noteAndRemarkNote: "Wenn Sie zur besuchten Qualifizierungsmaßnahme noch weitere Hinweise und Anmerkungen haben, können Sie diese nachfolgend schildern:"
  },
  trainingReports: {
    addTrainingReport: "Schulungsreports hinzufügen",
    updateTrainingReport: "Schulungsreports aktualisieren",
    addNewTrainingReport: "Neuen Schulungsreport hinzufügen",
    trainingReport: "Schulungsreport",
    nr: "Nr.",
    trainingTitle: "Unterrichtsthema",
    trainingDescription: "Schulungsbeschreibung",
    ue: "UE",
    signature: "Unterschrift",
    pdfCreated: "PDF erstellt",
    createdTrainingPDFs: "Erstellt Schulungs PDFs",
    courseDate: "Kurs Datum",
  },
  form: form
};